import React from 'react'
import {useState, useEffect } from 'react'
import { Box, Typography } from '@mui/material';

import Last12MonthPayments from './Last12MonthPayments';
import HoursReportFilter from './HoursReportFilter';
import PaymentCardComponent from './PaymentCardComponent';
import supabase from '../../../../supabaseClient';
import { computeWeeklyBonusesForPeriod } from '../../../../Utils/machineProductionStats';

const EMPTY_PRODUCTION_HISTORY = { rows: [], totalValue: 0 };

function NewHoursReport({ idConfig }){
    const [filterState, setFilterState] = useState(null);
    const [refreshTick, setRefreshTick] = useState(0);
    const [productionByEmployee, setProductionByEmployee] = useState({});

    // Produkcja dla wszystkich pracowników danej konfiguracji/okresu pobierana jest
    // RAZ tutaj (nie employeeId-scoped), bo fetchProductionLogs i tak zwraca te same
    // dane niezależnie od pracownika — pobieranie per-karta mnożyło egress razy liczba
    // pracowników. Wiersze są teraz tygodniowe (jeden na tydzień ISO), nie sesyjne.
    useEffect(() => {
        if (!filterState) return;
        let cancelled = false;
        computeWeeklyBonusesForPeriod(supabase, {
            idConfiguration: idConfig, dateFrom: filterState.dateFrom, dateTo: filterState.dateTo,
        }).then((rows) => {
            if (cancelled) return;
            const byEmployee = {};
            rows.forEach((r) => {
                const bucket = byEmployee[r.employeeId] || (byEmployee[r.employeeId] = { rows: [], totalValue: 0 });
                bucket.rows.push(r);
                bucket.totalValue += r.value;
            });
            setProductionByEmployee(byEmployee);
        });
        return () => { cancelled = true; };
    }, [idConfig, filterState?.dateFrom, filterState?.dateTo]);

    return(
        <Box>
            <Typography
                variant="h5"
                component="h1"
                sx={{
                    fontFamily: '"Roboto Condensed", sans-serif',
                    fontSize: '1.5rem',   // 27px
                    fontWeight: 700,
                    letterSpacing: '-0.2px',
                    color: 'primary.main',
                    mb: 0.25,                // 2px
                }}
            > Rozliczenia pracowników </Typography>

            <Last12MonthPayments idConfig={idConfig} />

            <Box sx={{ mt: 3 }}>
                <HoursReportFilter idConfig={idConfig} onFilterChange={setFilterState} refreshTick={refreshTick} />
            </Box>

            <Box sx={{ mt: 2 }}>
                {filterState && filterState.employees.length === 0 && (
                    <Typography sx={{ color: 'text.secondary', textAlign: 'center', py: 4 }}>
                        Brak pracowników spełniających wybrane filtry
                    </Typography>
                )}

                {filterState?.employees.map((emp) => (
                    <PaymentCardComponent
                        key={emp.id}
                        employee={emp}
                        idConfig={idConfig}
                        dateFrom={filterState.dateFrom}
                        dateTo={filterState.dateTo}
                        rules={filterState.rules}
                        onChanged={() => setRefreshTick((t) => t + 1)}
                        productionHistory={productionByEmployee[emp.id] || EMPTY_PRODUCTION_HISTORY}
                    />
                ))}
            </Box>
        </Box>
    )
}


export default NewHoursReport;